export function appointmentOperationIndexValidate(appointment){
    var result = true;

    result = validateId(appointment.id);
    result = validateClient(appointment.client);
    result = validateContainerNumber(appointment.container_number);
    result = validateArrivalDate(appointment.arrival_date);
    result = validateOperation(appointment.operation);
    
    return result;
}

function validateId(id) {
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateClient(client) {
    return (typeof client === 'object' && typeof client.name === 'string');
}

function validateContainerNumber(container_number) {
    return (typeof container_number === 'string');
}

function validateArrivalDate(arrival_date) {
    return (typeof arrival_date === 'string')
}

function validateOperation(operation) {
    return (typeof operation === 'object' && typeof operation.description === 'string' && typeof operation.description1 === 'string')
}